import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=2d7d6cac"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7d6cac')) {
      api.createRecord('2d7d6cac', component.options)
    } else {
      api.reload('2d7d6cac', component.options)
    }
    module.hot.accept("./PasswordReset.vue?vue&type=template&id=2d7d6cac", function () {
      api.rerender('2d7d6cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PasswordReset.vue"
export default component.exports